"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useFlowInstances(query) {
  const { ...rest } = useElements("flow-instances", query);
  return {
    flowInstances: rest.items,
    ...rest
  };
}

export { useFlowInstances };
